import { render, staticRenderFns } from "./ReviewUpLimit.vue?vue&type=template&id=9a13ad30&scoped=true"
import script from "./ReviewUpLimit.vue?vue&type=script&lang=js"
export * from "./ReviewUpLimit.vue?vue&type=script&lang=js"
import style0 from "./ReviewUpLimit.vue?vue&type=style&index=0&id=9a13ad30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a13ad30",
  null
  
)

export default component.exports